import React from 'react'
import {
  AppBar,
  Toolbar,
  Dialog,
  Typography,
  DialogContent,
  DialogActions,
  Button
} from '@material-ui/core'
import Loader from 'components/Loader'
import useStyles from './styles'


const Modal = (props) => {
  const {
    open,
    onClose,
    isLoading,
    header,
    children,
    action,
    actionText,
    secondaryAction,
    secondaryActionText,
    onEnter,
    maxWidth,
    additionalContentClasses,
    additionalHeaderClasses,
    disableEnforceFocus,
    primaryActionClass,
    dialogActionsClass,
    disableBackdropClick,
    secondaryActionId,
    primaryActionId
  } = props
  const localClasses = useStyles()

  return (
    <Dialog
      maxWidth={maxWidth || 'sm'}
      fullWidth
      open={open}
      onClose={onClose}
      onEnter={onEnter}
      disableEnforceFocus={disableEnforceFocus}
      className={localClasses.dialog}
      disableBackdropClick={disableBackdropClick}
    >
      { isLoading ? <Loader /> : null }
      <AppBar
        position='static'
        color='transparent'
        elevation={0}
        className={`${localClasses.appBar} ${additionalHeaderClasses || ''}`}
      >
        <Toolbar disableGutters className={localClasses.toolBar}>
          <Typography variant='subtitle1' className={localClasses.appBarHeader}>
            {header}
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent className={`${localClasses.dialogContent} ${additionalContentClasses || ''}`}>
        { children ? children : null}
        {
          action || secondaryAction ?
            <DialogActions
              className={`${localClasses.dialogActions} ${dialogActionsClass || ''}`}
            >
            {
              secondaryAction ?
                <Button
                  id={secondaryActionId || 'secondaryActionButton'}
                  type='submit'
                  onClick={secondaryAction}
                  variant='outlined'
                  color='secondary'
                  disableElevation
                  fullWidth
                >
                  { secondaryActionText || 'Cancel' }
                </Button> : null
            }
            {
              action ?
                <Button
                  id={primaryActionId || 'primaryActionButton'}
                  type='submit'
                  onClick={action}
                  variant='contained'
                  color={primaryActionClass ? 'default' : 'secondary'}
                  className={primaryActionClass || ''}
                  disableElevation
                  fullWidth
                >
                  { actionText || 'Submit' }
                </Button> : null
            }
            </DialogActions> : null
        }
      
      </DialogContent>
    </Dialog>
  )
}


export default Modal
